import { render, staticRenderFns } from "./Transacciones.vue?vue&type=template&id=6a3306fc&"
import script from "./Transacciones.vue?vue&type=script&lang=js&"
export * from "./Transacciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports